import { Typography } from "antd";
const { Title, Paragraph } = Typography;

const PrivacyPolicy = () => {
  return (
    <div className="container ">
      <div className="shadow-lg rounded-2xl p-4">
        <Title level={2} className="text-center">
          سياسة الخصوصية لحجوزاتي
        </Title>
        <Title level={3} className="text-center">
          جمع واستخدام بياناتك الشخصية
        </Title>
        <Paragraph className="text-center">
          نحن ملتزمون بحماية بياناتك ومعلوماتك وخصوصيتك.
        </Paragraph>

        <Paragraph>
          تطبيق ومنصة حجوزاتي (شركة الإمداد النموذجي للتجارة) ملتزمة بتوفير أعلى
          مستوى من الحماية فيما يتعلق بمعالجة بيانات العملاء / المستفيدين
          الشخصية بناءً على أنظمة وقوانين حماية البيانات واللوائح المعمول بها في
          المملكة العربية السعودية. ويوضح كيفية جمع البيانات في حجوزاتي،
          واستخدامها، وتخزينها، وأيضا آلية التعامل مع اكتشاف ومعالجة بياناتك
          الشخصية. وينطبق ذلك عليك في كل مرة تستخدم فيها المنصة/التطبيق والموقع
          الالكتروني بما في ذلك إذا كنت عميلًا / مستفيدًا فرديًا أو ممثلًا لعميل
          / مستفيد تابع لمؤسسة أو لشركة (بما في ذلك العملاء / المستفيدين
          السابقين والحاليين والمحتملين).
        </Paragraph>

        <Title level={4}>أنواع البيانات المجمعة</Title>

        <Title level={5}>البيانات الشخصية</Title>
        <Paragraph>
          تتكون البيانات الشخصية من جميع المعلومات التي تجمعها وتراجعها المنصة
          /التطبيق/الشركة عنك والتي يمكن أن تحدد هويتك بشكل مباشر أو غير مباشر،
          بما في ذلك المعلومات المستلمة من الأطراف الثالثة والمعلومات المجمعة من
          خلال استخدام التطبيق والموقع الإلكتروني، ملفات تعريف الارتباط، أو
          التكنولوجيا الأخرى المشابهة بشكل أكثر تحديداً، قد تتضمن البيانات
          الشخصية التي تجمعها أو تعالجها الشركة عنك ما يلي:
        </Paragraph>
        <Paragraph>
          <ul className="list-disc pr-6 text-right">
            <li>
              معلومات التعرف، بما في ذلك اسمك، تاريخ ميلادك، مكان ولادتك،
              جنسيتك، بلد إقامتك، تفاصيل تصريح الإقامة، الهوية الوطنية، تفاصيل
              الجواز، معلومات وسائل التواصل والصورة.
            </li>
            <li>
              تفاعلاتنا معك، بما في ذلك أي سجلات للمكالمات الهاتفية بينك وبين
              التطبيق والشركة، وسجلات المعلومات ذات الصلة بما في ذلك رقم هاتفك،
              والوقت والتاريخ للمكالمات والرسائل، ومدة المكالمات، ومعلومات
              التوجيه، وأنواع المكالمات.
            </li>
            <li>
              المعرفات الداخلية التي تعينها المنصة /التطبيق/الشركة لك، مثل
              علاقتك التجارية، الشريك، المعلومات، اسم المشروع، الخدمات المقدمة
              أو التي تقدمها أو معرف العميل / المستفيد.
            </li>
            <li>
              معلومات الاتصال، بما في ذلك العنوان البريدي، العنوان الوطني، رقم
              الهاتف، البريد الالكتروني ورقم الجوال.
            </li>
            <li>
              البيانات والمعلومات المتعلقة بالاستبيانات والتقييم وخدمة استطلاع
              الرأي التي ستساهم بشكل كبير في القدرة على تحليل واقع مقدمي الخدمات
              والخدمات وجودتها، وتسهيل وضع التحديات والحلول. كما تسهم هذه الجهود
              في إعداد الدراسات وتحليلها بفعالية لدعم عملية تطوير الأنظمة في
              الشركة وتحقيق أهداف التطوير.
            </li>
          </ul>
        </Paragraph>
        <Paragraph>
          إذا كان لديك أي أسئلة أو شكاوى بشأن هذه السياسة الخاصة بالخصوصية أو
          حماية بياناتك الشخصية، يرجى الاتصال بقطاع دعم العملاء والشركاء على
          العناوين التالية:
        </Paragraph>
        <Paragraph>
          <strong>شركة الإمداد النموذجي للتجارة</strong>
          <br />
          <strong>رقم الاتصال:</strong> 0582213156
          <br />
          <strong>المملكة العربية السعودية</strong>
          <br />
          <strong>البريد الالكتروني:</strong> info@imdaed.com
        </Paragraph>

        <Title level={5}>بيانات الاستخدام</Title>
        <Paragraph>
          يتم جمع بيانات الاستخدام تلقائيًا عند استخدام الخدمة.
        </Paragraph>
        <Paragraph>
          قد تتضمن بيانات الاستخدام معلومات مثل الإنترنت الخاص بجهازك عنوان
          البروتوكول (مثل عنوان IP)، ونوع المتصفح ، وإصدار المتصفح ، صفحات
          خدمتنا التي تزورها ، ووقت وتاريخ الزيارة ، والوقت الذي يقضيه في تلك
          الصفحات ، ومعرفات الجهاز الفريدة وبيانات التشخيص الأخرى.
        </Paragraph>
        <Paragraph>
          عندما تصل إلى الخدمة عن طريق أو من خلال جهاز محمول ، يجوز لنا ذلك جمع
          معلومات معينة تلقائيًا ، بما في ذلك ، على سبيل المثال لا الحصر يقتصر
          على نوع الجهاز المحمول الذي تستخدمه ، جهازك المحمول معرف فريد ، عنوان
          IP لجهازك المحمول ، هاتفك المحمول نظام التشغيل ، نوع متصفح الإنترنت
          على الهاتف المحمول الذي تستخدمه ، معرّفات الجهاز الفريدة وبيانات
          التشخيص الأخرى.
        </Paragraph>
        <Paragraph>
          قد نقوم أيضًا بجمع المعلومات التي يرسلها متصفحك متى شئت أنت تزور
          خدمتنا أو عندما تصل إلى الخدمة عن طريق أو من خلال جهاز محمول.
        </Paragraph>

        <Title level={5}>المعلومات التي تم جمعها أثناء استخدام التطبيق</Title>
        <Paragraph>
          أثناء استخدام تطبيقنا ، من أجل توفير ميزات التطبيق ، قد نجمع ، بإذن
          مسبق منك:
        </Paragraph>
        <Paragraph>
          <strong>معلومات بخصوص موقعك:</strong>
          <br />
          نستخدم هذه المعلومات لتقديم ميزات خدمتنا إلى تحسين خدماتنا وتخصيصها.
          قد يتم تحميل المعلومات إلى خوادم الشركة و / أو خادم مزود الخدمة أو ذلك
          قد يتم تخزينها ببساطة على جهازك. يمكنك تمكين أو تعطيل الوصول إلى هذه
          المعلومات في أي وقت ، من خلال إعدادات جهازك.
        </Paragraph>

        <Title level={4}>استخدام بياناتك الشخصية</Title>
        <Paragraph>
          يجوز للشركة استخدام البيانات الشخصية للأغراض التالية:
        </Paragraph>
        <Paragraph>
          <ul className="list-disc pr-6 text-right">
            <li>
              لتقديم خدماتنا والحفاظ عليها, متضمنا بما في ذلك مراقبة استخدام
              خدمتنا.
            </li>
            <li>
              لإدارة حسابك: لإدارة تسجيلك كمستخدم للخدمة. يمكن أن تمنحك البيانات
              الشخصية التي تقدمها إمكانية الوصول إلى الوظائف المختلفة للخدمة
              المتاحة لك كمستخدم مسجل.
            </li>
            <li>
              لتنفيذ العقد: التطوير والامتثال والتعهد بعملية الشراء عقد للمنتجات
              أو العناصر أو الخدمات التي لديك تم شراؤها أو أي عقد آخر معنا من
              خلال خدمة.
            </li>
            <li>
              للاتصال بك: للاتصال بك عن طريق البريد الإلكتروني أو المكالمات
              الهاتفية أو الرسائل النصية القصيرة أو غيرها من أشكال الاتصالات
              الإلكترونية المماثلة ، مثل الإخطارات الفورية لتطبيقات الهاتف
              المحمول فيما يتعلق بالتحديثات أو الاتصالات الإعلامية المتعلقة
              بالوظائف أو المنتجات أو الخدمات المتعاقد عليها ، بما في ذلك
              التحديثات الأمنية ، عند الضرورة أو المعقول لتنفيذها.
            </li>
            <li>
              لنوفر لك: مع الأخبار والعروض الخاصة ومعلومات عامة عن السلع
              والخدمات والأحداث الأخرى التي نقدمها مماثلة لتلك التي لديك بالفعل
              اشتريت أو استفسرت عما لم تكن قد اخترت عدم القيام بذلك تلقي هذه
              المعلومات.
            </li>
            <li>لإدارة طلباتك: لحضور وإدارة طلباتك إلينا.</li>
            <li>
              لنقل الأعمال: قد نستخدم الخاص بك معلومات لتقييم أو إجراء الاندماج
              أو التجريد ، إعادة الهيكلة أو إعادة التنظيم أو حل أو بيع أخرى أو
              نقل بعض أو كل أصولنا ، سواء كان ذلك قيد التنفيذ القلق أو كجزء من
              الإفلاس أو التصفية أو ما شابه ذلك ، حيث البيانات الشخصية التي
              نحتفظ بها حولنا مستخدمو الخدمة من بين الأصول المنقولة.
            </li>
            <li>
              لأغراض أخرى: قد نستخدم الخاص بك معلومات لأغراض أخرى ، مثل تحليل
              البيانات ، تحديد اتجاهات الاستخدام ، وتحديد فعالية الحملات
              الترويجية ولتقييم خدمتنا وتحسينها ، المنتجات والخدمات والتسويق
              وتجربتك.
            </li>
          </ul>
        </Paragraph>

        <Title level={4}>مشاركة البيانات الشخصية</Title>
        <Paragraph>
          قد نشارك معلوماتك الشخصية في بعض الحالات والمواقف:
        </Paragraph>
        <Paragraph>
          <ul className="list-disc pr-6 text-right">
            <li>
              مع مزودي الخدمة: قد نشارك المعلومات الشخصية بك مع مزودي الخدمة
              لمراقبة وتحليل استخدام خدمتنا، لتنفيذ الطلبات، ولتقديم الخدمات
              والعروض، والتقييمات، وللاتصال بك.
            </li>
            <li>
              لنقل الأعمال: يجوز لنا مشاركة أو نقل معلوماتك الشخصية فيما يتعلق
              أو أثناء مفاوضات، أي اندماج، بيع أصول الشركة، تمويل، أو الاستحواذ
              على كل أو جزء من أعمالنا إلى شركة أو شخص آخر.
            </li>
            <li>
              مع المسوقين بالعمولة: قد نشارك معلوماتك مع الشركات التابعة لنا،
              وفي هذه الحالة سيطلب من الشركات التابعة احترام سياسة الخصوصية هذه.
              تشمل الشركات التابعة لنا الشركة الأم وأي شركات تابعة أخرى أو
              مندمجة حاضراً او مستقبلاَ، مشروع مشترك مع الشركاء أو الشركات
              الأخرى التي نتعاقد معها أو نسيطر عليها.
            </li>
            <li>
              مع شركاء الأعمال: قد نشارك بك المعلومات مع شركائنا في العمل لنقدم
              لك بعض المعلومات المنتجات أو الخدمات أو العروض الترويجية.
            </li>
            <li>
              مع مستخدمين آخرين: عندما تشارك المعلومات الشخصية من خلال طلب سداد
              أو تقسيم الفواتير، أو يطلب أحد المستخدمين وكنت قد تفاعلت معه
              بطريقة أخرى أو ارسال اسم المستخدم أو رقم هاتفك المسجل لدينا.
            </li>
            <li>بموافقتك: قد نكشف عن المعلومات الشخصية لأي غرض آخر.</li>
          </ul>
        </Paragraph>

        <Title level={4}>الاحتفاظ ببياناتك الشخصية</Title>
        <Paragraph>
          ستحتفظ الشركة ببياناتك الشخصية طالما كانت ضرورية لأغراض سياسة
          الخصوصية. سنستخدم بياناتك وفقًا للقوانين وحل النزاعات وتنفيذ
          اتفاقياتنا وسياساتنا القانونية.
        </Paragraph>
        <Paragraph>
          تحتفظ الشركة ببيانات الاستخدام لأغراض التحليل الداخلي. عادةً يتم
          الاحتفاظ بهذه البيانات لفترة قصيرة، إلا إذا كانت تُستخدم لتعزيز الأمان
          أو تحسين وظائف الخدمة، أو إذا كان القانون يتطلب احتفاظنا بها لفترات
          أطول.
        </Paragraph>

        <Title level={4}>نقل بياناتك الشخصية</Title>
        <Paragraph>
          تُعالج معلوماتك، بما في ذلك البيانات الشخصية، في مكاتب الشركة وأماكن
          المعالجة الأخرى. قد يتم نقل المعلومات والاحتفاظ بها على أجهزة كمبيوتر
          خارج ولايتك أو بلدك، حيث قد تختلف قوانين حماية البيانات. موافقتك على
          سياسة الخصوصية هذه عند تقديمك لهذه المعلومات تعني موافقتك على هذا
          النقل.
        </Paragraph>
        <Paragraph>
          ستتخذ الشركة جميع الخطوات الضرورية لضمان التعامل الآمن مع بياناتك
          وفقًا لسياسة الخصوصية، ولن يتم نقلها إلا عند توفر الضوابط الأمنية
          المناسبة.
        </Paragraph>

        <Title level={4}>احذف بياناتك الشخصية</Title>
        <Paragraph>يمكنك حذف بياناتك الشخصية أو طلب مساعدتنا في ذلك.</Paragraph>
        <Paragraph>
          قد تمنحك خدمتنا القدرة على حذف معلومات معينة عنك من داخل الخدمة.
        </Paragraph>
        <Paragraph>
          يمكنك تعديل معلوماتك أو حذفها عن طريق تسجيل الدخول إلى حسابك وزيارة
          إعدادات الحساب. يمكنك أيضًا طلب الوصول لتصحيح أو حذف أي معلومات شخصية
          قدمتها لنا عبر الاتصال بنا.
        </Paragraph>
        <Paragraph>
          يرجى العلم أننا قد نحتاج إلى الاحتفاظ ببعض المعلومات عندما يكون لدينا
          التزام قانوني أو أساس قانوني للقيام بذلك.
        </Paragraph>

        <Title level={4}>الإفصاح عن بياناتك الشخصية</Title>

        <Title level={5}>المعاملات التجارية</Title>
        <Paragraph>
          في حالة الاندماج أو الاستحواذ أو بيع الأصول، قد تُنقل بياناتك الشخصية.
          سيتم إخطارك قبل نقل البيانات وخضوعها لسياسة خصوصية جديدة.
        </Paragraph>

        <Title level={5}>تطبيق القانون</Title>
        <Paragraph>
          في ظروف محددة، قد تكون الشركة ملزمة بالكشف عن بياناتك الشخصية إذا تطلب
          القانون ذلك، أو استجابةً للطلبات المشروعة من السلطات العامة، مثل
          المحاكم أو الوكالات الحكومية.
        </Paragraph>

        <Title level={5}>المتطلبات القانونية الأخرى</Title>
        <Paragraph>
          قد تُفصح الشركة عن بياناتك الشخصية إذا اعتبرت أن هذا الإجراء ضروري من
          أجل:
        </Paragraph>
        <Paragraph>
          <ul className="list-disc pr-6 text-right">
            <li>الامتثال للقانون</li>
            <li>حماية حقوق وممتلكات الشركة</li>
            <li>منع أو التحقيق في المخالفات المحتملة</li>
            <li>ضمان سلامة مستخدمي الخدمة والجمهور</li>
            <li>الحماية من المسؤولية القانونية</li>
          </ul>
        </Paragraph>

        <Title level={4}>أمن بياناتك الشخصية</Title>
        <Paragraph>
          أمان بياناتك الشخصية مهم لنا، لكن لا توجد طريقة آمنة بنسبة 100٪
          للإرسال عبر الإنترنت أو التخزين الإلكتروني. نسعى لحمايتها بأفضل الطرق
          الممكنة تجاريًا، ولكن لا يمكننا ضمان أمنها المطلق.
        </Paragraph>

        <Title level={4}>خصوصية الأطفال</Title>
        <Paragraph>
          لا تجمع المنصة /التطبيق/الشركة أي معلومات شخصية قابلة للتعرف من
          الأطفال أو الأشخاص الذين تقل أعمارهم عن (18) عامًا. إذا كنت تعتقد أن
          أحد الأشخاص قدم هذا النوع من المعلومات على موقعنا الالكتروني عمره يقل
          عن (18) عاماً، نشجعك بشدة على الاتصال بنا على الفور وسنضمن إزالة هذه
          المعلومات من سجلاتنا بشكل فوري.
        </Paragraph>

        <Title level={4}>وسائل الإعلام الاجتماعية</Title>
        <Paragraph>
          تدير المنصة /التطبيق/الشركة قنوات وصفحات وحسابات على بعض مواقع التواصل
          الاجتماعي لإبلاغ ومساعدة والتفاعل مع العملاء / المستفيدين. تراقب
          المنصة /التطبيق/الشركة وتسجل التعليقات والمنشورات التي تُدرج على هذه
          القنوات حول المنصة /التطبيق/الشركة لتحسين خدماتها.
        </Paragraph>
        <Paragraph>
          يرجى ملاحظة أنه يجب ألا تتواصل مع المنصة /التطبيق/الشركة من خلال مواقع
          التواصل الاجتماعي هذه الأنواع التالية من المعلومات:
        </Paragraph>
        <Paragraph>
          البيانات الشخصية السرية، بما في ذلك أي معلومات حول وضعك المالي، تفاصيل
          الحساب المصرفي، المعاملات، إلخ.
        </Paragraph>
        <Paragraph>
          البيانات الشخصية الحساسة بما في ذلك (أ) فئات خاصة من البيانات الشخصية
          بمعنى أي معلومات تكشف عن الأصل العرقي أو العنصري، الآراء السياسية،
          المعتقدات الدينية أو الفلسفية، أو عضوية نقابة العمال، ومعالجة البيانات
          الجينية، البيانات القياسية الحيوية بهدف التعرف الفريد على الشخص
          الطبيعي، البيانات المتعلقة بالصحة أو البيانات المتعلقة بحياة الشخص
          الطبيعية الجنسية أو التوجه الجنسي و (ب) البيانات الشخصية الحساسة
          الأخرى مثل الإدانات الجنائية والمخالفات ورقم الهوية الوطنية. معلومات
          زائدة، غير مناسبة، مهينة أو تهجمية تجاه الأفراد.
        </Paragraph>
        <Paragraph>
          المنصة /التطبيق/الشركة ليست مسؤولة عن أي معلومات تم نشرها على تلك
          المواقع باستثناء المعلومات التي تم نشرها بواسطة موظفيها نيابة عنها.
          المنصة /التطبيق/الشركة مسؤولة فقط عن استخدامها الخاص للبيانات الشخصية
          المستلمة من خلال تلك المواقع.
        </Paragraph>

        <Title level={4}>روابط لمواقع أخرى</Title>
        <Paragraph>
          تحتوي خدمتنا على روابط لمواقع خارجية. عند النقر على رابط جهة خارجية،
          ستُوجه إلى موقع الطرف الثالث. نوصي بشدة بمراجعة سياسة الخصوصية لكل
          موقع تزوره.
        </Paragraph>
        <Paragraph>
          لا نتحكم ولا نتحمل مسؤولية المحتوى أو سياسات الخصوصية أو ممارسات
          المواقع أو الخدمات التابعة لطرف ثالث.
        </Paragraph>

        <Title level={4}>التغييرات على سياسة الخصوصية هذه</Title>
        <Paragraph>
          سنقوم بتحديث سياسة الخصوصية من وقت لآخر، وسيتم الإعلان عن أي تغييرات
          عبر نشر السياسة الجديدة على هذه الصفحة. سيتم إرسال إشعار عبر البريد
          الإلكتروني و/أو إشعار بارز على موقع الخدمة قبل أن يصبح التغيير ساريًا.
          يُنصح بمراجعة سياسة الخصوصية بشكل دوري للاطلاع على أي تغييرات. تكون
          التغييرات فعالة عند نشرها على هذه الصفحة.
        </Paragraph>

        <Title level={4}>موافقتك على هذه الشروط</Title>
        <Paragraph>
          باستخدامك لهذا المنصة /التطبيق ، فإنك تعبر عن موافقتك على هذه السياسة.
          إذا كنت لا توافق على هذه السياسة، فيرجى عدم استخدام المنصة /التطبيق.
          سيعتبر استخدامك المستمر المنصة /التطبيق بعد نشر التغييرات على هذه
          السياسة موافقتك على هذه التغييرات.
        </Paragraph>

        <Title level={4}>اتصل بنا</Title>
        <Paragraph>
          إذا كان لديك أي أسئلة أو شكاوى بخصوص سياسة الخصوصية هذه، أو حماية
          بياناتك الشخصية، أو ممارسات هذا المنصة /التطبيق ، أو تعاملاتك مع هذا
          المنصة /التطبيق ، أي اشتباه في اختراق للبيانات الشخصية، فيرجى الاتصال
          بقطاع دعم العملاء والشركاء في المنصة /التطبيق على العنوان التالي:
        </Paragraph>
        <Paragraph>
          <strong>شركة الإمداد النموذجي للتجارة</strong>
          <br />
          <strong>رقم الاتصال:</strong> 0582213156
          <br />
          <strong>المملكة العربية السعودية</strong>
          <br />
          <strong>البريد الالكتروني:</strong> info@imdaed.com
        </Paragraph>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
